import { createSlice } from "@reduxjs/toolkit";
import { fetchCategoryProducts, fetchAllCategories } from "../actions/CategoryActions";

const CategoryReducers = createSlice({
    name: 'CategoryReducers',
    initialState: {
        loader: false,
        errors: null,
        categories: [],
        categoryProducts: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * Category Products
             */
            .addCase(fetchCategoryProducts.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(fetchCategoryProducts.fulfilled, (state, action) => {
                const { category, products } = action.payload;
                state.loader = false;
                state.categoryProducts[category] = products;
            })
            .addCase(fetchCategoryProducts.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * Fetch All Categories
             */
            .addCase(fetchAllCategories.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(fetchAllCategories.fulfilled, (state, action) => {
                state.loader = false;
                state.categories = action.payload;
            })
            .addCase(fetchAllCategories.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })
    }
});

export default CategoryReducers.reducer;
